import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/account/view/license.account.link.mutation.gql"
import type {
  LinkBillingAccountMutation,
  LinkBillingAccountMutationVariables,
} from "@/v2-backoffice-client/license/account/view/__types__/license.account.link.mutation"

type Options = MutationHookOptions<
  LinkBillingAccountMutation,
  LinkBillingAccountMutationVariables
>

export function useLinkBillingAccountMutation(options?: Options) {
  return useMutation<
    LinkBillingAccountMutation,
    LinkBillingAccountMutationVariables
  >(mutation, options)
}
